import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useIssueInvoice, useQuotes } from '@/hooks/useDesk';
import { formatDate, formatNadFromCents } from '@/lib/format';

export function QuotesPage() {
  const { data, isLoading, isError, error } = useQuotes();
  const issue = useIssueInvoice();

  return (
    <div>
      <PageHeader
        title="Quotes"
        description="Quotes linked to clients and events."
        actions={
          <Link
            to="/quotes/quick"
            className="rounded-lg bg-dome-brass px-3 py-2 text-sm font-medium text-dome-ink"
          >
            Quick quote
          </Link>
        }
      />

      {isLoading ? (
        <p className="animate-pulse-soft text-sm text-[var(--muted)]">Loading…</p>
      ) : null}
      {isError ? (
        <p className="text-sm text-dome-danger">{(error as Error).message}</p>
      ) : null}
      {issue.isError ? (
        <p className="mb-3 text-sm text-dome-danger">
          {(issue.error as Error).message}
        </p>
      ) : null}

      {!isLoading && data && data.length === 0 ? (
        <EmptyState
          title="No quotes yet"
          body="Use Quick quote for a fast phone-friendly path."
        />
      ) : null}

      {data && data.length > 0 ? (
        <DataTable
          headers={['Number', 'Client', 'Event', 'Total', 'Status', 'Created', '']}
        >
          {data.map((row) => (
            <tr key={row.id}>
              <td className="px-3 py-2 font-mono text-xs">{row.quote_number}</td>
              <td className="px-3 py-2">
                {row.domeec_clients?.company_name || '—'}
              </td>
              <td className="px-3 py-2">{row.domeec_events?.name || '—'}</td>
              <td className="px-3 py-2">
                {formatNadFromCents(row.total_cents)}
              </td>
              <td className="px-3 py-2">
                <StatusBadge status={row.status} />
              </td>
              <td className="px-3 py-2 text-[var(--muted)]">
                {formatDate(row.created_at)}
              </td>
              <td className="px-3 py-2 text-right">
                <button
                  type="button"
                  className="text-sm font-medium text-dome-leaf disabled:opacity-50"
                  disabled={issue.isPending}
                  onClick={() => issue.mutate(row.id)}
                >
                  Issue invoice
                </button>
              </td>
            </tr>
          ))}
        </DataTable>
      ) : null}
    </div>
  );
}
